<div #scrollContainer class="container content-login" 
style="background-color: lightgray; height: 100vh; overflow-y: auto;" [formGroup]="userForm">
  <div class="row logoheader">
    

    <div class="col-12 outline-0 text-center mt-1 mb-1">
      <div class="logo-background text-center" style="margin: 0 auto;width: 38%">
        <img src="./assets/images/OlarmewithMerchantMate.png" class="logo-background" />
      </div>
    </div>
  </div>

  <div class="px-2 text-center col-12 alert alert-info alert-dismissible fade show mt-3" role="alert" *ngIf="showSuccess">
    <h5 class="alert-heading">🎉 You've successfully joined our loyalty program!</h5>
    <p>
      Please remember to <strong>scan the QR code</strong> and use your <strong>registered phone number</strong>
      when placing future orders to collect reward points.
    </p>

  </div>
  <div class="px-2 text-center alert alert-success alert-dismissible fade show mt-3" role="alert" *ngIf="showAlreadyRegistered">
    <h5 class="alert-heading">⚠️ You're already a loyalty member!</h5>
    <p>
      This phone number is already registered. Just <strong>scan the QR code</strong> and use it
      when you order to keep earning points.
    </p>

  </div>
  <ng-container *ngIf="!showSuccess">

    <div class="row form-group mx-2 my-4">
      <div class="col">
        <span class="text-danger mt-2" style="position: absolute;left: 1%;">*</span>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: white !important;">
              <i class="far fa-user" aria-hidden="true"></i>
            </span>
          </div>
          <input type="text" formControlName="name" class="form-control border-0 form-control-lg" placeholder="Name"
            aria-label="Name"
            [ngClass]="{'has-error': ((userForm.get('name').touched || userForm.get('name').dirty) &&  userForm.get('name').errors)}" />
          <div class="input-group-append">
            <span class="input-group-text mr-1 cursor" (click)="genderClick('1')"
              [ngClass]="{'btn-color text-white': male, 'btn-light text-dark': !male }">
              <small>M</small>
            </span>
            <span class="input-group-text cursor" (click)="genderClick('0')"
              [ngClass]="{'btn-color text-white': !male, 'btn-light text-dark': male }">
              <small>F</small>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="row form-group cart-phone-form-group mx-2 my-4">
      <div class="col">
        <span class="text-danger mt-2" style="position: absolute;left: 1%;">*</span>
        <ngx-intl-tel-input [cssClass]="'form-control form-control-lg border-0'"
          [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="false" [enablePlaceholder]="true"
          [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false" [selectedCountryISO]="selectedCountryISO" [maxLength]="15"
          [phoneValidation]="true" [separateDialCode]="separateDialCode" name="phone" formControlName="phone"
          [ngClass]="{'has-error': ((userForm.get('phone').touched || userForm.get('phone').dirty) &&  userForm.get('phone').errors)}">
        </ngx-intl-tel-input>
      </div>
    </div>

    <div class="row form-group mx-2 my-4">
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: white !important;">
              <i class="far fa-envelope" aria-hidden="true"></i>
            </span>
          </div>
          <input type="text" formControlName="email" class="form-control border-0" placeholder="Email (optional)"
            [ngClass]="{'has-error': ((userForm.get('email').touched || userForm.get('email').dirty) &&  userForm.get('email').errors)}"
            aria-label="Email (optional)">
        </div>
      </div>
    </div>

    <div class="row form-group mx-2 my-4">
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: white !important;">
              <i class="fa fa-birthday-cake" aria-hidden="true"></i>
            </span>
          </div>
          <!-- <input type="text" formControlName="birthday" class="form-control border-0" placeholder="Bithday (optional)"
          [ngClass]="{'has-error': ((userForm.get('email').touched || userForm.get('email').dirty) &&  userForm.get('email').errors)}"
          aria-label="Email (optional)"> -->

          <input [maxDate]="today" type="text" placeholder="Bithday (optional)" class="form-control" bsDatepicker
            formControlName="birthday">

        </div>
      </div>
    </div>

    <div class="row form-group mx-2 my-4">
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: white !important;">
              <i class="fa fa-users" aria-hidden="true"></i>
            </span>
          </div>

          <ng-select class="form-control p-0" [items]="ageGroupList" bindLabel="name" bindValue="id"
            placeholder="Select a group" formControlName="age_group">
          </ng-select>

        </div>
      </div>
    </div>
    <div class="row form-group mx-2 my-4">
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" style="background-color: white !important;">
              <i class="fa fa-home" aria-hidden="true"></i>
            </span>
          </div>
          <input type="text" formControlName="address" class="form-control border-0" placeholder="Address (optional)"
            aria-label="Email (optional)">
        </div>
      </div>
    </div>

    <div class="row form-group mx-2 my-4">
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" style="visibility: hidden;">
              <i class="fa fa-home" aria-hidden="true"></i>
            </span>
          </div>
          <input type="text" formControlName="state" class="form-control border-0" placeholder="State (optional)"
            aria-label="Email (optional)">
        </div>
      </div>
    </div>

    <div class="row form-group mx-2 my-4">
      <div class="col">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" style="visibility: hidden;">
              <i class="fa fa-home" aria-hidden="true"></i>
            </span>
          </div>
          <input type="text" formControlName="country" class="form-control border-0" placeholder="Country (optional)"
            aria-label="Email (optional)">
        </div>
      </div>
    </div>


    <div class="row form-group">
      <div class="col text-center">
        <button [disabled]="userForm.invalid" (click)="onSignUpClick()"
          class="btn text-white outline-0 box-shadow-none badge-pill" style="background-color: #3e97e6 !important;">
          Submit
        </button>
      </div>
    </div>
  </ng-container>

  <br />
  <br />
  <br />
  <div class="row">
    <div class="col">
      <small>By logging into your account you agree to our Terms and conditions
      </small>
    </div>
  </div>
  <div class="row form-group">
    <div class="col">
      <small>Please read our
      </small>
      <small class="text-primary cursor" (click)="onClickPrivacy()">Privacy and Cookies Policy.</small>
    </div>
  </div>
</div>
<app-loading-component></app-loading-component>
<app-toast [message]="toastMessage" [visible]="showToast"></app-toast>